import { render, staticRenderFns } from "./InfluencerDataTable.vue?vue&type=template&id=4956e560&"
import script from "./InfluencerDataTable.vue?vue&type=script&lang=js&"
export * from "./InfluencerDataTable.vue?vue&type=script&lang=js&"
import style0 from "./InfluencerDataTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports